// extracted by mini-css-extract-plugin
export default {"heading-wrapper":"communication_heading-wrapper__quwEH","heading":"communication_heading__L2XDV","all-chat-container":"communication_all-chat-container__DC9d3"};